The webhook subscription for the given `id`.
